function getTitle (vm) {
    const { title } = vm.$options;
    if (title) {
        return typeof title === 'function'
            ? title.call(vm)
            : title
    }
}

function setTitle (vm) {
    const title = getTitle(vm);
    if (title) {
        document.title = title
    }
}

export default {
    created () {
        if (!this.$options.title) return;
        setTitle(this);
        // re-apply the (translated) title when the user switches language
        if (this.$i18n) this.$watch(() => this.$i18n.locale, () => setTitle(this));
    }
}
